export default class TimelineExpand {
    static init(): void {
        const timelineSection = document.querySelector('.timeline-section__item');
        if (!timelineSection) return;
        const timelineItems = document.querySelectorAll<HTMLElement>('.timeline-item-box');
        const textElements = document.querySelectorAll<HTMLElement>('.timeline-item__text');
        const textElementsBox = document.querySelectorAll<HTMLElement>('.timeline-item-box__inner');
        const tooltipTriggers = document.querySelectorAll<HTMLElement>('[data-bs-toggle="tooltip"]');
        const timelineGrid = document.querySelector<HTMLElement>('.timeline__grid');
        const timelineScroll = document.querySelector<HTMLElement>('.timeline__scroll');

        if (!timelineItems.length || !timelineGrid) return;

        const transitionDuration = '0.5s';

        let isExpanded = false;

        const setCollapsedState = () => {
            timelineItems.forEach((item) => {
                item.style.width = '3.9rem';
                item.style.height = '3.9rem';
                item.style.borderRadius = '50%';
                item.style.transition = `all ${transitionDuration} ease`;
                item.style.overflow = 'hidden';
            });

            textElements.forEach((text) => {
                text.style.opacity = '0';
                text.style.transition = `opacity ${transitionDuration} ease`;
            });

            textElementsBox.forEach((box) => {
                box.style.opacity = '0';
                box.style.transition = `opacity ${transitionDuration} ease`;
            });

            tooltipTriggers.forEach((trigger) => {
                trigger.style.pointerEvents = 'none';
            });

            timelineGrid.style.display = 'flex';
            timelineGrid.style.justifyContent = 'flex-start';
            timelineGrid.style.gap = '8px';
            timelineGrid.style.width = '';

            if (timelineScroll) timelineScroll.style.overflowX = 'hidden';

            isExpanded = false;
        };

        const setExpandedState = () => {
            timelineItems.forEach((item) => {
                item.style.width = '';
                item.style.height = '';
                item.style.borderRadius = '';
                item.style.overflow = '';
            });

            textElements.forEach((text) => {
                text.style.opacity = '1';
                text.style.transition = `opacity ${transitionDuration} ease`;
            });

            textElementsBox.forEach((box) => {
                box.style.opacity = '1';
                box.style.transition = `opacity ${transitionDuration} ease`;
            });

            tooltipTriggers.forEach((trigger) => {
                trigger.style.pointerEvents = 'auto';
            });

            timelineGrid.style.display = 'grid';
            timelineGrid.style.justifyContent = '';
            timelineGrid.style.gap = '';
            timelineGrid.style.width = '100%';

            if (timelineScroll) timelineScroll.style.overflowX = 'auto';

            isExpanded = true;
        };

        const onScroll = () => {
            const rect = timelineSection.getBoundingClientRect();
            const isVisible = rect.top < window.innerHeight - 100 && rect.bottom > 100;

            if (isVisible && !isExpanded) {
                setCollapsedState();

                setTimeout(() => {
                    setExpandedState();
                }, 100);
            }
        };

        window.addEventListener('scroll', onScroll);
        window.addEventListener('resize', () => {
            if (isExpanded) {
                setExpandedState();
            } else {
                setCollapsedState();
            }
        });

        setCollapsedState();
    }
}
